import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

import HomePage from "@/pages/HomePage";
import ToursPage from "@/pages/ToursPage";
import TourDetailPage from "@/pages/TourDetailPage";
import BookingPage from "@/pages/BookingPage";
import BookingSuccessPage from "@/pages/BookingSuccessPage";
import CustomTripPage from "@/pages/CustomTripPage";
import CustomTripSuccessPage from "@/pages/CustomTripSuccessPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import FAQPage from "@/pages/FAQPage";
import GalleryPage from "@/pages/GalleryPage";
import ComparePage from "@/pages/ComparePage";
import NotFoundPage from "@/pages/NotFoundPage";
import CompareBar from "@/components/CompareBar";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col bg-[#FAF6F0] text-[#23170E]">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/tours" element={<ToursPage />} />
            <Route path="/tours/:slug" element={<TourDetailPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/booking-success" element={<BookingSuccessPage />} />
            <Route path="/custom-trip" element={<CustomTripPage />} />
            <Route path="/custom-trip-success" element={<CustomTripSuccessPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/kilimanjaro" element={<Navigate to="/tours" replace />} />
            <Route path="*" element={<NotFoundPage />} />
            <Route path="/admin/bookings" element={<AdminPage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <CompareBar />
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
